import type { JsonValue } from 'type-fest';

export const parseXml = <T = JsonValue>(xml: string): T => {
  const serialize = (element: Element) => {
    if (!element.children.length) {
      return Number.isNaN(Number(element.innerHTML))
        ? element.innerHTML
        : Number(element.innerHTML);
    }

    return [...element.children].reduce<Record<string, JsonValue>>(
      (json, child) => {
        if (child.nodeName in json) {
          if (Array.isArray(json[child.nodeName])) {
            (json[child.nodeName] as JsonValue[]).push(serialize(child));
          } else {
            json[child.nodeName] = [json[child.nodeName], serialize(child)];
          }
        } else {
          json[child.nodeName] = serialize(child);
        }

        return json;
      },
      {}
    );
  };

  const parser = new DOMParser();
  const { documentElement } = parser.parseFromString(xml, 'application/xml');

  return serialize(documentElement) as T;
};
